import { api, getWithOptionalAuthorization, postWithOptionalAuthorization } from './api';
import { USER_BASE } from './apiConstant';
import { getToken, setToken } from './auth';
import { decryptMessage } from '../utils/decrypt';

interface LoginCredentials {
  email: string;
  password: string;
  [key: string]: any; // In case there are other fields
}

interface LoginResponse {
  accessToken: string;
  [key: string]: any;
}

interface UserResponse {
  id: string;
  fullName: string;
  email: string;
  role: string;
  status: number;
  [key: string]: any; // Add more fields as needed
}

export type UserMobilePostBody = {
    emailID: string;
    mobileNo: string;
};

export interface Country {
  id: string;
  name: string;
  code: string;
  flag: string;
  isdCode: string;
}

export type MobileExistPostBody = {
    emailID: string;
    mobileNo: string;
};

export type CountriesResponse = Country[];

const userApi = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const responseLogin = await postWithOptionalAuthorization(`${USER_BASE}/login`, credentials, false);
    const token = responseLogin.data.accessToken;
    if (token) {
      setToken(token);
    }
    return responseLogin;
  },

  // Response RAW JSON data (decrypted data)
  getUser: async (): Promise<UserResponse> => {
    try {
      const encryptedUserResponse = await getWithOptionalAuthorization(`${USER_BASE}`, true);
      const token = getToken();
      if (!token) {
        throw new Error('No token found');
      }
      const decryptedMessage = await decryptMessage(encryptedUserResponse.data.Data, token);
      
      return decryptedMessage;
    } catch (error) {
      console.error('Error fetching user:', error);
      throw error;
    }
  },

  postUserMobile: async (body: UserMobilePostBody) => {
      const encryptedUserMobileResponse = await postWithOptionalAuthorization(`${USER_BASE}/Update-mobile`, body, true);
      const updateUserMobileResponse = decryptMessage(encryptedUserMobileResponse.data.Data, getToken());
      return updateUserMobileResponse;
  },

  getCountries: async (): Promise<CountriesResponse> => {
    try {
      const response = await getWithOptionalAuthorization(`${USER_BASE}/GetCountries`, false);
      console.log("API raw response:", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching countries:', error);
      throw error;
    }
  },
  isUserMobileExist: async (body: MobileExistPostBody) => {
    try {
      const encryptedUserMobileExistResponse = await postWithOptionalAuthorization(`${USER_BASE}/Check-override-mobile`, body, true);
      const isUserMobileExistResponse = decryptMessage(encryptedUserMobileExistResponse.data.Data, getToken());
      return isUserMobileExistResponse;
    } catch (error) {
      console.error('Error fetching isUserMobileExist:', error);
      throw error;
    }
  },

};

export default userApi;